import React, { createContext, useState } from "react";
import Utils from "../../utils";
import { ADMIN_GROUP_NAME } from "../../helpers/constant";
import { getAlertsAPI } from "../../services/alerts";

// AppDataContext Definition
export const AppDataContext = createContext();

export const AppDataContextProvider = ({ children }) => {
    const [campaign, setCampaign] = useState({ id: "", name: "" });
    const [insightName, setInsightName] = useState("");
    const [currentCompanyAlerts, setCurrentCompanyAlerts] = useState([]);
    const [loadingAlerts, setLoadingAlerts] = useState(false);
    const [unreadCounts, setUnreadCounts] = useState(0);

    const clearAppData = () => {
        const emptyObject = {
            id: "",
            name: ""
        }
        setCampaign({ ...emptyObject });
        setInsightName("");
    }

    const loadCompanyAlertsData = async (loader = true) => {
        setLoadingAlerts(loader);
        try {
            const { user, groups } = await Utils.getCurrentUserAndGroups();
            const nonAdminGroup = groups.filter((z) => z !== ADMIN_GROUP_NAME);

            if (nonAdminGroup.length === 0) {
                setCurrentCompanyAlerts([]);
                return;
            }

            const data = await getAlertsAPI({
                limit: 50,
                lastKey: null,
            })

            const alerts = data.items;
            setUnreadCounts(data.unreadCount)
            const sortedAlerts = alerts.sort((a, b) => a.createdAt > b.createdAt ? -1 : 1);
            setCurrentCompanyAlerts([...sortedAlerts]);
            setLoadingAlerts(false);
        } catch (error) {
            setLoadingAlerts(false);
            console.error("Error loading company alerts data:", error);
            setCurrentCompanyAlerts([]);
        }
    }

    return (
        <AppDataContext.Provider value={{
            campaign, setCampaign,
            insightName, setInsightName,
            currentCompanyAlerts, setCurrentCompanyAlerts,
            unreadCounts,
            loadCompanyAlertsData, loadingAlerts,
            clearAppData
        }}>
            {children}
        </AppDataContext.Provider>
    );
};
